<template>
    <div class="section-block record-block">
        <div class="section-title">案件笔录信息</div>
        <el-scrollbar class="record-scrollbar" v-loading="recordLoading">
            <div v-if="recordList.length" class="record-list">
                <div
                    v-for="(item, index) in recordList"
                    :key="item.id || index"
                    class="record-item"
                >
                    <div class="record-icon-wrap">
                        <img src="@/assets/images/Investigation/transcript.png" alt="笔录" class="record-icon" />
                    </div>
                    <div class="record-body">
                        <div class="record-title">{{ item.title || '单位笔录-李经理' }}</div>
                        <div class="record-remark" v-if="item.investigatedPerson">被调查人: {{ item.investigatedPerson }}</div>
                        <div class="record-remark">备注: {{ item.remark || '-' }}</div>
                        <div class="record-actions">
                            <el-button type="primary" link size="small" @click="handleView(item)">查看</el-button>
                            <el-button type="success" link size="small" @click="handleDownload(item)">下载</el-button>
                            <el-button type="danger" link size="small" @click="handleDelete(item)">删除</el-button>
                        </div>
                    </div>
                </div>
            </div>
            <div v-else class="record-empty">暂无案件笔录记录</div>
        </el-scrollbar>

        <el-dialog :visible.sync="viewVisible" title="查看笔录" width="560px" append-to-body>
            <el-descriptions v-if="currentRecord" :column="1" border>
                <el-descriptions-item label="笔录类型">{{ currentRecord.transcriptTypeLabel || '-' }}</el-descriptions-item>
                <el-descriptions-item label="被调查人">{{ currentRecord.investigatedPerson || '-' }}</el-descriptions-item>
                <el-descriptions-item label="调查时间">{{ currentRecord.investigateTime || '-' }}</el-descriptions-item>
                <el-descriptions-item label="调查地点">{{ currentRecord.investigatePlace || '-' }}</el-descriptions-item>
                <el-descriptions-item label="标题">{{ currentRecord.title || '-' }}</el-descriptions-item>
                <el-descriptions-item label="备注说明">{{ currentRecord.remark || '-' }}</el-descriptions-item>
                <el-descriptions-item label="上传时间">{{ currentRecord.createTime || '-' }}</el-descriptions-item>
            </el-descriptions>
            <template #footer>
                <el-button @click="viewVisible = false">关闭</el-button>
                <el-button type="primary" @click="handleDownload(currentRecord); viewVisible = false">下载文件</el-button>
            </template>
        </el-dialog>
    </div>
</template>

<script>
export default {
    name: 'TranscriptRecordList',
    data() {
        return {
            recordLoading: false,
            recordList: [],
            viewVisible: false,
            currentRecord: null
        }
    },
    created() {
        this.loadRecordList()
    },
    methods: {
        loadRecordList() {
            this.recordLoading = true
            setTimeout(() => {
                this.recordList = []
                this.recordLoading = false
            }, 200)
        },
        handleView(item) {
            this.currentRecord = item
            this.viewVisible = true
        },
        handleDownload(item) {
            if (!item || !item.fileUrl) {
                this.$message.warning('暂无文件地址')
                return
            }
            const url = item.fileUrl.startsWith('http') ? item.fileUrl : (this.imageUrlprefix || '') + item.fileUrl
            window.open(url, '_blank')
        },
        handleDelete(item) {
            this.$confirm('确认删除该笔录记录？', '提示', { type: 'warning' })
                .then(() => {
                    this.recordList = this.recordList.filter((r) => (r.id || r) !== (item.id || item))
                    this.$message.success('删除成功')
                })
                .catch(() => {})
        }
    }
}
</script>

<style lang="scss" scoped>
.section-block {
    margin-bottom: 24px;
    background: #fff;
    border-radius: 4px;
    padding: 20px;

    .section-title {
        position: relative;
        font-size: 14px;
        font-weight: 500;
        color: #303133;
        padding-left: 11px;
        margin-bottom: 12px;

        &::before {
            content: '';
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
            width: 3px;
            height: 12px;
            border-radius: 20px;
            background: var(--vt-c-blue);
        }
    }
}

.record-block .section-title {
    flex-shrink: 0;
}

.record-scrollbar {
    min-height: 200px;
    max-height: 320px;

    :deep(.el-scrollbar__wrap) {
        overflow-x: hidden;
    }
}

.record-list {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.record-item {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    padding: 12px;
    background: #fafafa;
    border-radius: 4px;
    border: 1px solid #ebeef5;
}

.record-icon-wrap {
    flex-shrink: 0;
    width: 48px;
    height: 48px;
}

.record-icon {
    width: 100%;
    height: 100%;
    object-fit: contain;
}

.record-body {
    flex: 1;
    min-width: 0;
}

.record-title {
    font-weight: 500;
    color: #303133;
    font-size: 14px;
    margin-bottom: 6px;
}

.record-remark {
    font-size: 13px;
    color: #606266;
    line-height: 1.5;
    margin-bottom: 8px;
}

.record-actions {
    display: flex;
    align-items: center;
    gap: 4px;
}

.record-empty {
    text-align: center;
    color: #909399;
    padding: 60px 0;
    font-size: 14px;
}
</style>
